/**
 * Open reference lightbox on page load if hash equals lightbox
 */
import {Utils} from "../Modules/Utils";
import {ImageSliderClass} from "../Modules/imageSlider";

// assume bootstrap is a global variable and exists (as it is included in app.ts)
declare var bootstrap: any
Utils.executeWhenDocumentIsReady( () => {
    if (window.location.hash) {
        const hash = window.location.hash
        const modalElement = document.querySelector<HTMLElement>(hash)

        if (modalElement && modalElement.classList.contains("modal")) {
            // Assuming you're using Bootstrap's Modal component
            const modal = new bootstrap.Modal(modalElement)
            modal.show()
        }
    }

    const modalToggles = document.querySelectorAll<HTMLAnchorElement>(
        'a[data-toggle="modal"]',
    )
    modalToggles.forEach((toggle) => {
        toggle.addEventListener("click", function () {
            window.location.hash = this.getAttribute("href") || ""
          document.querySelectorAll('.c-image-slider__carousel').forEach((item) => {
            new ImageSliderClass(item);
          });

        })
    })

    function revertToOriginalURL() {
        const original = window.location.href.substr(
            0,
            window.location.href.indexOf("#"),
        )
        history.replaceState({}, document.title, original)
    }

    const modals = document.querySelectorAll<HTMLElement>(".modal")
    modals.forEach((modal) => {
        // Assuming you're using Bootstrap's Modal component
        modal.addEventListener("hidden.bs.modal", function () {
            revertToOriginalURL()
        })
    })
})
